var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal fade", attrs: { id: _vm.modalId } }, [
    _c(
      "div",
      {
        staticClass: "modal-dialog modal-dialog-scrollable modal-xs",
        attrs: { role: "document" }
      },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("activityColumns")) +
                "\n                "
            ),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: {
                  type: "button",
                  "data-toggle": "modal",
                  "data-target": "#" + _vm.modalId
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close.apply(null, arguments)
                  }
                }
              },
              [_vm._v("×")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-6 container" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("b", [
                      _vm._v(" " + _vm._s(_vm.$t("activityHidden")) + " ")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.unselectedColumns.length
                    ? [
                        _c(
                          "ul",
                          { staticClass: "row list-group w-100" },
                          _vm._l(_vm.unselectedColumns, function(item) {
                            return _c(
                              "li",
                              {
                                key: item.id,
                                staticClass: "list-group-item ptr p-1 px-2",
                                on: {
                                  click: function($event) {
                                    return _vm.selectedColumn(item)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("acs" + item)) +
                                    "\n                                "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    : [
                        _c("div", { staticClass: "row" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s("(" + _vm.$t("txtEmpty") + ")") +
                              "\n                            "
                          )
                        ])
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6 container" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("b", [_vm._v(_vm._s(_vm.$t("activityVisible")))])
                  ]),
                  _vm._v(" "),
                  _vm.selectedColumns.length
                    ? [
                        _c(
                          "ul",
                          { staticClass: "row list-group w-100" },
                          _vm._l(_vm.selectedColumns, function(item) {
                            return _c(
                              "li",
                              {
                                key: item.id,
                                staticClass: "list-group-item ptr p-1 px-2",
                                on: {
                                  click: function($event) {
                                    return _vm.unselectedColumn(item)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("acs" + item)) +
                                    "\n                                "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    : [
                        _c("div", { staticClass: "row" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s("(" + _vm.$t("txtEmpty") + ")") +
                              "\n                            "
                          )
                        ])
                      ]
                ],
                2
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }